<template>
  <div>
    <div v-if="userData">
      <form id="formSendStat" v-on:submit.prevent="sendStat" method="POST">
        <CRow>
          <CCol lg="12">
            <CCard>
              <CCardHeader
                class="bg-danger text-white text-center"
                style="padding: 20px"
                ><h3>
                  แบบประเมินความพึงพอใจของผู้เข้ารับการอบรม<br />
                  โครงการเพิ่มศักยภาพครูให้มีสมรรถนะของครูยุคใหม่สำหรับการเรียนรู้ศตวรรษที่
                  21 (พ.ศ. 2564)
                </h3></CCardHeader
              >
              <CCardBody>
                <div style="padding-top: 20px">
                  <u>คำอธิบาย:</u>
                  ขอความกรุณาให้ผู้ตอบแบบประเมินตอบตามความเป็นจริงหรือตามความคิดเห็นของท่านมากที่สุด
                  เพื่อให้การดำเนินโครงการเป็นไปตามวัตถุประสงค์และเป็นประโยชน์ในการนำไปปรับปรุงการจัดอบรมต่อไป
                </div>
                <CRow>
                  <CCol lg="6" style="padding-top: 20px"
                    >ระบุเขตพื้นที่ที่ท่านสังกัด (หากไม่มี ให้พิมพ์คำว่า
                    "ไม่ระบุ"):
                  </CCol>
                  <CCol lg="6" style="padding-top: 20px"
                    ><input
                      type="text"
                      class="form-control"
                      name="txtArea"
                      required
                  /></CCol>
                </CRow>
                <div style="padding-top: 20px">
                  <strong>ตอนที่ 1: </strong
                  ><u>ระดับความพึงพอใจต่อการเข้าร่วมการอบรม:</u><br />
                  โปรดเลือกตอบระดับความพึงพอใจที่ตรงกับความคิดเห็นหรือความพึงพอใจของท่านเพียงระดับเดียว
                </div>
                <div class="table table-responsive">
                  <table class="table table-bordered">
                    <thead>
                      <tr class="text-center">
                        <th rowspan="2" width="10%">ข้อ</th>
                        <th rowspan="2">ประเด็นการประเมิน</th>
                        <th colspan="5">ระดับความพึงพอใจ</th>
                      </tr>
                      <tr class="text-center">
                        <td width="10%">มากที่สุด</td>
                        <td width="10%">มาก</td>
                        <td width="10%">ปานกลาง</td>
                        <td width="10%">น้อย</td>
                        <td width="10%">น้อยที่สุด</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colspan="7">1. กระบวนการจัดอบรม</td>
                      </tr>
                      <tr>
                        <td>1.1</td>
                        <td>การประชาสัมพันธ์การจัดอบรม</td>
                        <td class="text-center">
                          <input
                            type="radio"
                            class=""
                            name="rdp11"
                            value="5"
                            required
                          />
                        </td>
                        <td class="text-center">
                          <input type="radio" class="" name="rdp11" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" class="" name="rdp11" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" class="" name="rdp11" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" class="" name="rdp11" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td>1.2</td>
                        <td>การชี้แจงรายละเอียดเกี่ยวกับการอบรม</td>
                        <td class="text-center">
                          <input
                            type="radio"
                            class=""
                            name="rdp12"
                            value="5"
                            required
                          />
                        </td>
                        <td class="text-center">
                          <input type="radio" class="" name="rdp12" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" class="" name="rdp12" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" class="" name="rdp12" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" class="" name="rdp12" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td>1.3</td>
                        <td>การติดต่อประสานงาน</td>
                        <td class="text-center">
                          <input type="radio" name="rdp13" value="5" required />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp13" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp13" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp13" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp13" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td>1.4</td>
                        <td>การอำนวยความสะดวกก่อนการอบรม</td>
                        <td class="text-center">
                          <input type="radio" name="rdp14" value="5" required />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp14" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp14" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp14" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp14" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td>1.5</td>
                        <td>ระยะเวลาในการจัดอบรม</td>
                        <td class="text-center">
                          <input type="radio" name="rdp15" value="5" required />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp15" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp15" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp15" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp15" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td>1.6</td>
                        <td>รูปแบบการจัดอบรม</td>
                        <td class="text-center">
                          <input type="radio" name="rdp16" value="5" required />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp16" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp16" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp16" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp16" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td>1.7</td>
                        <td>ความเหมาะสมของจำนวนวิทยากร</td>
                        <td class="text-center">
                          <input type="radio" name="rdp17" value="5" required />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp17" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp17" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp17" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp17" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td colspan="7">2. สภาพแวดล้อมและสิ่งอำนวยความสะดวก</td>
                      </tr>
                      <tr>
                        <td>2.1</td>
                        <td>ระบบการอบรมออนไลน์ที่ใช้</td>
                        <td class="text-center">
                          <input type="radio" name="rdp21" value="5" required />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp21" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp21" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp21" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp21" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td>2.2</td>
                        <td>
                          การเตรียมความพร้อมและการอำนวยความสะดวกก่อนการใช้ระบบออนไลน์แก่ผู้อบรม
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp22" value="5" required />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp22" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp22" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp22" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp22" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td>2.3</td>
                        <td>ความสะดวกในการเข้าระบบการอบรมออนไลน์</td>
                        <td class="text-center">
                          <input type="radio" name="rdp23" value="5" required />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp23" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp23" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp23" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp23" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td>2.4</td>
                        <td>
                          การแก้ปัญหา/การอำนวยความสะดวกแก่ผู้อบรมในระหว่างการอบรม
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp24" value="5" required />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp24" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp24" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp24" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp24" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td>2.5</td>
                        <td>ความเหมาะสมของจำนวนผู้เข้าอบรม</td>
                        <td class="text-center">
                          <input type="radio" name="rdp25" value="5" required />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp25" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp25" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp25" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp25" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td>2.6</td>
                        <td>บรรยากาศระหว่างการอบรม</td>
                        <td class="text-center">
                          <input type="radio" name="rdp26" value="5" required />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp26" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp26" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp26" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp26" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td colspan="7">3. การถ่ายทอดความรู้ของวิทยากร</td>
                      </tr>
                      <tr>
                        <td>3.1</td>
                        <td>การเตรียมตัวและความพร้อมของวิทยากร</td>
                        <td class="text-center">
                          <input type="radio" name="rdp31" value="5" required />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp31" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp31" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp31" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp31" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td>3.2</td>
                        <td>การถ่ายทอดเนื้อหาสอดคล้องกับวัตถุประสงค์</td>
                        <td class="text-center">
                          <input type="radio" name="rdp32" value="5" required />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp32" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp32" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp32" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp32" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td>3.3</td>
                        <td>การถ่ายทอดเนื้อหาทำให้เกิดความเข้าใจในเนื้อหา</td>
                        <td class="text-center">
                          <input type="radio" name="rdp33" value="5" required />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp33" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp33" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp33" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp33" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td>3.4</td>
                        <td>การถ่ายทอดเนื้อหาน่าสนใจ</td>
                        <td class="text-center">
                          <input type="radio" name="rdp34" value="5" required />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp34" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp34" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp34" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp34" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td>3.5</td>
                        <td>การชี้แจงกิจกรรมและดำเนินกิจกรรมการอบรม</td>
                        <td class="text-center">
                          <input type="radio" name="rdp35" value="5" required />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp35" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp35" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp35" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp35" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td>3.6</td>
                        <td>การตอบคำถาม/นำอภิปราย</td>
                        <td class="text-center">
                          <input type="radio" name="rdp36" value="5" required />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp36" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp36" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp36" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp36" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td>3.7</td>
                        <td>การจัดสรรเวลาในแต่ละหัวข้อการอบรม</td>
                        <td class="text-center">
                          <input type="radio" name="rdp37" value="5" required />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp37" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp37" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp37" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp37" value="1" />
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">4. ความพึงพอใจในภาพรวมของการจัดอบรม</td>
                        <td class="text-center">
                          <input type="radio" name="rdp4" value="5" required />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp4" value="4" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp4" value="3" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp4" value="2" />
                        </td>
                        <td class="text-center">
                          <input type="radio" name="rdp4" value="1" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div style="padding-top: 20px">
                  <strong>ตอนที่ 2:</strong> การนำความรู้ไปใช้ประโยชน์
                </div>
                <div style="padding-top: 20px">
                  ท่านคิดว่าสิ่งที่ได้รับจากการอบรมในครั้งนี้สามารถนำไปใช้ประโยชน์ด้านใดบ้าง
                  (เลือกได้มากกว่า 1 ข้อ)
                </div>
                <CRow>
                  <CCol lg="12">
                    <div class="relative w-full mb-3">
                      <div class="form-check">
                        <input
                          class="form-check-input chkSubject"
                          type="checkbox"
                          name="chkKnowledge[]"
                          value="1"
                        />
                        <label class="form-check-label" for="flexCheckDefault">
                          นำไปใช้ในการจัดการเรียนรู้ในชั้นเรียน
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input chkSubject"
                          type="checkbox"
                          name="chkKnowledge[]"
                          value="2"
                        />
                        <label class="form-check-label" for="flexCheckDefault">
                          นำไปใช้ในการวิจัย/วิจัยในชั้นเรียน
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input chkSubject"
                          type="checkbox"
                          name="chkKnowledge[]"
                          value="3"
                        />
                        <label class="form-check-label" for="flexCheckDefault">
                          นำไปถ่ายทอดหรือเผยแพร่ให้กับผู้อื่น
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input chkSubject"
                          type="checkbox"
                          name="chkKnowledge[]"
                          value="4"
                        />
                        <label class="form-check-label" for="flexCheckDefault">
                          อื่น ๆ (จงอธิบาย)
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          name="txtOther"
                        />
                      </div>
                    </div>
                  </CCol>
                  <CCol lg="4"> ความคิดเห็นหรือข้อเสนอแนะเพิ่มเติม: </CCol>
                  <CCol lg="8">
                    <textarea class="form-control" name="txtComment"></textarea>
                  </CCol>
                </CRow>
              </CCardBody>
              <CCardFooter class="text-right">
                <button type="submit" class="btn btn-link">ส่ง</button>
              </CCardFooter>
            </CCard>
          </CCol>
        </CRow>
      </form>
    </div>
    <div v-else class="alert alert-danger">
      กรุณา logout แล้ว login อีกครั้ง
    </div>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import XLSX from "xlsx"; // import xlsx

import Table from "./base/Table.vue";
import moment from "moment";
import usersData from "./users/UsersData";

export default {
  name: "Dashboard",
  components: {
    VueGoodTable,
    Datepicker,
    vSelect,
    XLSX,
  },
  data() {
    return {
      responseContent: null,
      darkModal: false,
      userData: this.$cookies.get("user"),
      testInfo: null,
      itemList: null,
      examAllow: false,
      examStart: null,
      storeKnowledge: null,
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {
    onExport() {
      const dataWS = XLSX.utils.json_to_sheet(this.rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "export.xlsx");
    },
    sendStat() {

      let cboxes = document.getElementsByName("chkKnowledge[]");
      let len = cboxes.length;
      this.storeKnowledge = 0;
      for (let i = 0; i < len; i++) {
        if (cboxes[i].checked) {
          this.storeKnowledge += 1;
        }
      }
      if (this.storeKnowledge == 0) {
        alert("กรุณาระบุการนำความรู้ไปใช้");
        return false;
      } else {
        const form = document.getElementById("formSendStat");
        const formData = new FormData(form);
        formData.append("txtAction", "create");
        formData.append("userId", this.userData.adminlogin_id);
        this.axios
          .post(this.$hostUrl + "php_action/satAPI2021.php", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            console.log(response.data);
            if (response.data.error != false) {
              alert(response.data.error);
              this.darkModal = true;
            } else {
              this.$router.push({ name: 'Posttest', params: { subjectId: this.userData.course_subject } });
              //this.$cookies.set("user", response.data.userData);
              //this.$store.commit("setUserData", this.$cookies.get("user"));
              //this.$router.push({ path: "../pages/searchTrainee" });
            }
          })
          .finally(() => {});
      }
    },
  },
};
</script>
